import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TagsInput } from '@eggplant/pattern-library'
import { useKeycloak } from '@eggplant/context'
import type {
  Principal,
  Tag
} from '@eggplant/types'
import type { ReactNode } from 'react'

export interface Props {
  onChange: (value: Principal[]) => void
  values: Principal[]
  isRequired?: boolean
  description?: ReactNode
  isDisabled?: boolean
}

const getTags = (users: Principal[]) => users.map(
  user => (
    {
      ...user,
      color: ''
    } as Tag
  )
)

const getVerifiedUsersTags = (users: Principal[]) => users.filter(user =>
  user.emailStatus === 'VERIFIED'
).map(user => ({
  ...user,
  color: ''
}))

const SelectNotificationRecipients = ({
  onChange,
  values,
  isRequired = false,
  description,
  isDisabled = false
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()

  const url = keycloakInstance.authServerUrl + 'realms/' + keycloakInstance.realm + '/dai/v1/users'

  const handleOnSelectedTagsChanged = (tags: Tag[]) => {
    const users = tags.map(
      tag => (
        {
          name: tag.name,
          id: tag.id,
          type: 'user'
        } as Principal
      )
    )

    onChange(users)
  }

  return (
    <AuthenticatedDataRequest
      method='get'
      url={url}
    >
      {
        (data: Principal[]) => {
          const availableTags = getVerifiedUsersTags(data)
          const selectedTags = getTags(values)

          const updatedTags = availableTags.filter(availableTag =>
            selectedTags.find(selectedTag =>
              selectedTag.id === availableTag.id
            )
          )

          return (
            <TagsInput
              availableTags={availableTags}
              description={description}
              isDisabled={isDisabled}
              isNewItemAllowed={false}
              // No point rendering dots since no Color information is returned from backend
              isRequired={isRequired}
              label='Recipients'
              maxLength={50}
              onSelectedTagsChanged={handleOnSelectedTagsChanged}
              placeholder='Select users to add to receive notifications'
              selectedTags={updatedTags}
            />
          )
        }
      }
    </AuthenticatedDataRequest>
  )
}

export default SelectNotificationRecipients
